<template>
    <Card :title="$t('labels.category')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-3">
                    <FormGroup :label="$t('categoryCard.labels.source_category')">
                        <AppSelect
                            option-key="key"
                            option-value="label"
                            :model-value="sourceCategory.key"
                            :selected-value="sourceCategory.label"
                            :options="sourceCategoryOptions"
                            :selected-values="!marketplaces.includes(integration.service) ? [CategorySourceEnum.SERVICE] : []"
                            @update:model-value="sourceCategory = $event"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-3" v-for="languageAlias in integration.language_aliases">
                    <FormGroup :label="`${$t('labels.name')} (${$t(`languages.${languageAlias}`)})`" required>
                        <Autocomplete
                            v-if="sourceCategory.key === CategorySourceEnum.SERVICE"
                            @update:model-value="marketplaceCategory = $event"
                            :model-value="marketplaceCategory?.id"
                            :selected-value="marketplaceCategory?.[`name_${languageAlias}`]"
                            :url="`/projects/${this.$route.params.projectUuid}/marketplace/sources/${this.integration.service}/categories`"
                            option-key="id"
                            :option-value="`name_${languageAlias}`"
                            :query-params="{
                                has_child: 0,
                                orders: [
                                    {column : 'name_uk', dir : 'asc'}
                                ]
                            }"
                        />
                        <Input v-model="names[languageAlias]" v-else/>
                    </FormGroup>
                </div>
                <div class="col-lg-3 d-flex align-items-center justify-content-end">
                    <Button color="teal" :style="{width: '100%'}" @click="$refs.categoryTreeModal.show()" :disabled="sourceCategory.key !== CategorySourceEnum.SERVICE">
                        <i class="icon-tree7 mr-2"></i>
                        {{ $t('categoryCard.buttons.find_by_tree') }}
                    </Button>
                </div>
                <div class="col-lg-6" v-for="languageAlias in integration.language_aliases" v-if="integration.service === IntegrationServiceEnum.PROM">
                    <FormGroup :label="`${$t('labels.seo')} (${$t(`languages.${languageAlias}`)})`">
                        <InputTag
                            v-model="seoKeywords[languageAlias]"
                        />
                    </FormGroup>
                </div>
            </div>
            <Alert type="warning" v-if="hasFilters === false">
                <span class="font-weight-semibold mr-2">{{ translate(`alerts.warning`) }}</span>
                {{ translate('alerts.category_hasnt_attributes') }}
            </Alert>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <Button color="indigo" @click="create" :disabled="!canCreate">
                {{ $t("buttons.create") }}
            </Button>
        </div>
    </Card>
    <CategoryTreeModal
        ref="categoryTreeModal"
        :selectedSourceId="marketplaceCategory?.source_id"
        :targetIntegrationService="integration.service"
        @update:selectedCategory="marketplaceCategory = $event"
    />
</template>
<script>
import Card from "../../../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../../components/new/form/Input.vue";
import Button from "../../../../../../components/new/button/AppButton.vue";
import Autocomplete from "../../../../../../components/new/form/autocomplete/AppAutoComplete.vue";
import Alert from "../../../../../../components/AlertComponent.vue";
import InputTag from "../../../../../../components/new/form/Tags.vue";
import AppSelect from "../../../../../../components/new/form/select/AppSelect.vue";
import CategoryTreeModal from "../../category/modals/CategoryTreeModal.vue";

import { httpClient } from "../../../../../../services/HttpClient";
import { IntegrationServiceEnum } from '../../../../../enums/IntegrationServiceEnum';
import { CategorySourceEnum } from '../../../../../enums/CategorySourceEnum';
import { getCommonMarketplaces } from '../../../../../enums/CommonMarketplaceEnum';

export default {
    name: "CreateCategoryPage",
    components: {
        Card, Input, FormGroup, Button, Autocomplete, Alert, InputTag, AppSelect, CategoryTreeModal
    },
    props: {
        integration: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            IntegrationServiceEnum,
            CategorySourceEnum,
            names: {},
            seoKeywords: {},
            sourceCategory: {
                key: CategorySourceEnum.CUSTOM,
                label: this.$t('categoryCard.labels.custom')
            },
            sourceCategoryOptions: [
                {key: CategorySourceEnum.CUSTOM, label: this.$t('categoryCard.labels.custom')},
                {key: CategorySourceEnum.SERVICE, label: this.$t('categoryCard.labels.from_service')}
            ],
            marketplaces: getCommonMarketplaces(),
            marketplaceCategory: null
        }
    },
    methods: {
        async create() {
            let requestData = {}

            let seo = Object.entries(this.seoKeywords).reduce((acc, [alias, translation]) => {
                if (translation) {
                    acc[alias] = translation;
                }
                return acc;
            }, {});

            if (Object.keys(seo).length > 0) {
                requestData.seo_keywords = seo;
            }

            if (this.sourceCategory.key === CategorySourceEnum.SERVICE) {
                if (this.integration.service === 'kasta') {
                    requestData.parent_source_id = String(this.marketplaceCategory.parent_source_id)
                }
                if (this.marketplaceCategory.name_uk) {
                    requestData.names = requestData.names || {};
                    requestData.names.uk = this.marketplaceCategory.name_uk;
                }
                if (this.marketplaceCategory.name_ru) {
                    requestData.names = requestData.names || {};
                    requestData.names.ru = this.marketplaceCategory.name_ru;
                }
                requestData.source_id = String(this.marketplaceCategory.source_id)
            } else {
                requestData.names = this.names
            }

            await httpClient.post(`/projects/${this.$route.params.projectUuid}/pim/channels/${this.integration.uuid}/categories`, requestData).then((response) => {
                this.$emit('created', response.data.data)
            }).then(() => {
                this.names = {}
                this.sourceId = null
                this.$router.push({name: "CategoriesCard"})
            })
        },
    },
    computed: {
        canCreate() {
            if (this.sourceCategory.key === CategorySourceEnum.SERVICE) {
                return this.marketplaceCategory !== null;
            } else {
                return Object.keys(this.names).length === this.integration.language_aliases.length
                    && Object.values(this.names).every(name => name && name.trim().length > 0);
            }
        }
    },
}
</script>
